export default __webpack_public_path__ + "apple_store.c60930b.svg";